<template>
  <tk-button
    :class="['filterButton', `-${color}`, { '-noBorder': noBorder }]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    絞り込み
    <tk-icon
      class="filterButton_filterIcon"
      name="filter"
      :color="color"
    />
    <span
      v-if="checkmark"
      :class="['filterButton_filterCheckArea', { '-noBorder': noBorder }]"
    >
      <tk-image
        class="filterButton_filterCheck"
        image-path="https://www.tabikobo.com/images/common/check_white.svg"
        alt="checked"
      />
    </span>
  </tk-button>
</template>

<script>
import { TkButton, TkIcon, TkImage } from '@ota-frontend/ui'

export default {
  components: { TkButton, TkIcon, TkImage },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: undefined,  // 'white', 'red', 'blue', 'black'
    },
    checkmark: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.filterButton {
  display: flex;
  align-items: center;
  position: relative;
  width: 100px;
  height: 36px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  font-weight: bold;

  &.-blue {
    border: 1px solid #bbd2e6;
    color: #1f6aad;
  }

  &.-noBorder {
    border: unset;
  }

  &:disabled {
    pointer-events: none;
    opacity: .5;
  }

  &:focus {
    outline: 0;
  }
}
.filterButton_filterIcon {
  margin-left: 5px;
}
.filterButton_filterCheckArea {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -5px;
  left: -5px;
  width: 18px;
  height: 18px;
  border-radius: 100px;
  background: #f9423a;
  color: white;
  line-height: 1;

  &.-noBorder {
    top: -1px;
    left: 0px;
  }
}
.filterButton_filterCheck {
  height: 6px;
}
</style>
